export default "__VITE_ASSET__CKjO1_P$__"